// extracted by mini-css-extract-plugin
export default {"questionText":"M_cX","info":"M_cY","question":"M_cR"};